import { createActionGroup, props } from '@ngrx/store';

export const applicationExistGuardActions = createActionGroup({
  source: 'Application Exists Guard',
  events: { 'Can Activate': props<{ id: string }>() },
});
